<template>
    
    <form class="form-horizontal" role="form" method="POST" @submit.prevent="submit">

    	<div v-if="success" class="alert alert-success alert-block">{{ message }}</div>
        <div v-if="error" class="alert alert-danger alert-block">{{ message }}</div>

        <div class="form-group required row">
            <label for="name" class="col-md-4 control-label text-md-right">Your name</label>
            <div class="col-md-6">
                <input id="name" type="text" class="form-control" name="name" v-model="fields.name" required>
                <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
            </div>
        </div>

        <div class="form-group required row">
            <label for="email" class="col-md-4 control-label text-md-right">Your e-mail address</label>
            <div class="col-md-6">
                <input id="email" type="email" class="form-control" name="email" v-model="fields.email" required>
                <div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}</div>
            </div>
        </div>

        <div class="form-group required row">
            <label for="email_text" class="col-md-4 control-label text-md-right">Your message</label>
            <div class="col-md-6">
                <textarea id="email_text" class="form-control" name="email_text" v-model="fields.email_text" rows="5" required></textarea>
                <div v-if="errors && errors.email_text" class="text-danger">{{ errors.email_text[0] }}</div>
            </div>
        </div>

        <hr>

        <div class="form-group row mb-0">
            <div class="col-md-3 offset-md-4">
                <button type="submit" class="btn btn-theme" :disabled="isSubmitting">
                    Send
                    <span v-if="isSubmitting">&nbsp;<b-spinner small label="Loading"></b-spinner></span>
                </button>
            </div>
            <div class="col-md-5">
                <div class="g-recaptcha"></div>
                <vue-recaptcha
                    ref="invisibleRecaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    size="invisible"
                    :sitekey="g_recaptcha_key">
                </vue-recaptcha>
                <div v-if="errors && errors.g_recaptcha_response && errors.g_recaptcha_response[0]!='validation.captcha'" class="text-danger">{{ errors.g_recaptcha_response[0] }}</div>
                <div v-if="errors && errors.g_recaptcha_response && errors.g_recaptcha_response[0]=='validation.captcha'" class="text-danger">An error occurred with reCaptcha.</div>
                <div v-if="cookie_ko" class="text-danger">reCaptcha's cookie needs to be authorized.</div>
            </div>
        </div>
    </form>

</template>

<script>
    import VueRecaptcha from 'vue-recaptcha'

    export default {
        components: {
            VueRecaptcha,
        },

        props: {
            csrfToken: {
                type: String,
                required: true
            },
            sitekey: {
                type: String,
                required: true
            },
        },

    	data() {
    		return {
                fields: {
                	_token: this.csrfToken,
                    g_recaptcha_response: "",
                	name: this.user == null ? "" : this.user.firstname + " " + this.user.lastname,
                	email: this.user == null ? "" : this.user.email,
                	email_text: "",
                },
                g_recaptcha_key: this.sitekey,
                cookie_ko: false,
                isSubmitting: false,
                errors: {},
                success: false,
                error: false,
                message: "",
            }
    	},

    	methods: {
            submit() {
                let cookie = this.$cookie.get( "tarteaucitron")
                let regex = /recaptcha=true/
                if( !regex.exec( cookie)) { // cookie reCaptcha refusé
                    this.cookie_ko = true
                } else {
                    this.cookie_ko = false
                    this.isSubmitting = true
                    this.$refs.invisibleRecaptcha.execute()
                }
            },

            onVerify: function (response) {
                this.resetRecaptcha()
                this.fields.g_recaptcha_response = response

                this.errors = {}
                this.success = false
                this.error = false
                this.message = ""

                axios.post( "/contact/send", this.fields)
                .then( response => {
                    this.success = true
                    this.message = response.data

                    if( this.user == null) {
                        for( let field in this.fields) {
                			if( field != "_token") {
                                this.fields[field] = ""
                            }
                        }
                    } else {
                        this.fields.email_text = ""
                    }

                    this.isSubmitting = false
                }).catch( error => {
                    if( error.response.status === 422) {
                        this.errors = error.response.data.errors || {}
                    } else if( error.response.status === 424) {
                        this.error = true
                        this.message = error.response.data
                    }
                    this.isSubmitting = false
                })
            },

            onExpired: function () {
                this.resetRecaptcha()
            },

            resetRecaptcha() {
                this.$refs.invisibleRecaptcha.reset()
            },
        },
    };
</script>